import * as React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { Box, Typography, Button } from '@mui/material'
import { KiddomStandardsResp } from './types'
import { kiddomStandardsAtom } from './atoms'
import { downloadFile } from 'shared/utils/fileExport'
import { openInNewTab } from '../../utility'
import { ExportStandardsToSheet } from './ExportStandardsToSheet'

interface KiddomStandardsViewProps {
  state: string
  subject: string
}

const downloadJson = (
  data: KiddomStandardsResp['data'],
  state: string,
  subject: string,
) => {
  const fileName = `kiddom_${state.replace(/\s+/g, '_')}_${subject.replace(/\s+/g, '_')}.json`
  downloadFile({
    fileName,
    fileDataString: JSON.stringify(data, null, 2),
    fileDataType: 'data:text/json;charset=utf-8',
  })
}

export const KiddomStandardsView: React.FC<KiddomStandardsViewProps> = ({
  state,
  subject,
}) => {
  const [kiddomStandards] = useAtom(kiddomStandardsAtom)

  const count = kiddomStandards?.data?.length || 0

  const handleDownload = () => {
    if (kiddomStandards?.data) {
      downloadJson(kiddomStandards.data, state, subject)
    }
  }

  const handleOpen = () => {
    if (kiddomStandards?.data) {
      openInNewTab({ data: kiddomStandards.data })
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        State: {state}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Subject: {subject}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" color="text.secondary">
          Number of Standards: {count}
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={handleOpen}
          disabled={!kiddomStandards?.data}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Open JSON
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={handleDownload}
          disabled={!kiddomStandards?.data}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Download Standards
        </Button>
      </Box>
      <ExportStandardsToSheet state={state} subjectName={subject} />
    </Box>
  )
}
